import { createI18n } from 'vue-i18n';

export const i18n = new createI18n({
  locale: 'en', // set initial locale
  fallbackLocale: 'en',
  // Legacy-mode spelling of `missingWarn` / `fallbackWarn` (see
  // vue-i18n's createI18n: it negates these into the composer flags).
  // Translations are injected at runtime from the shell and /json-i18n,
  // so falling back to `en` is the normal path, not a defect.
  silentTranslationWarn: true,
  silentFallbackWarn: true,
});
